"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  LISTBOX_SELECTION_TYPES: true,
  ORIENTATION_TYPES: true,
  LISTBOX_SELECTOR_POSITIONS: true,
  Listbox: true
};
exports.default = exports.ORIENTATION_TYPES = exports.Listbox = exports.LISTBOX_SELECTOR_POSITIONS = exports.LISTBOX_SELECTION_TYPES = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _arrFlatten = _interopRequireDefault(require("arr-flatten"));
var _isPrintableKeyEvent = _interopRequireDefault(require("is-printable-key-event"));
var _reactInfiniteScrollHook = _interopRequireDefault(require("react-infinite-scroll-hook"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _isFunction = require("../utils/isFunction");
var _useKeyStrokes = require("../utils/useKeyStrokes");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _descendantManager = require("../utils/descendantManager");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _listOptions = require("../utils/_listOptions");
var _BusyIndicator = require("../BusyIndicator/BusyIndicator");
var _ListboxGroup = require("./_ListboxGroup");
var _ListboxItem = require("./_ListboxItem");
var _ListContext = require("./_ListContext");
var _listboxUtils = require("./_listboxUtils");
var _Listbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Listbox.css") : void 0);
var _Listbox2 = require("./Listbox.types");
Object.keys(_Listbox2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Listbox2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Listbox2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/no-array-index-key */

const CSS_BLOCK = 'sapcnqr-listbox';
const ID_SEPARATOR = '-_-_-';
const LISTBOX_SELECTION_TYPES = exports.LISTBOX_SELECTION_TYPES = ['singleSelectMaster',
// used to pick one item with no additional indicator
'singleSelectLeft',
// used to pick one item using a radio button
'multiSelect' // used to pick several items from the list using checkboxes on the far left
];
const ORIENTATION_TYPES = exports.ORIENTATION_TYPES = ['horizontal', 'vertical'];
const LISTBOX_SELECTOR_POSITIONS = exports.LISTBOX_SELECTOR_POSITIONS = ['top-start', 'top-center', 'top-end', 'middle-start', 'middle-end', 'bottom-start', 'bottom-center', 'bottom-end'];
/**
 * The **Listbox** component is an alternative to a **List** that should
 * be used when the ability to select items is required.
 */
const Listbox = exports.Listbox = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b;
  const {
      ariaLabelledby,
      bordered,
      className,
      groupLabelRenderer,
      groupProps,
      hideOuterFocusRing,
      infinite,
      ignoreFirstAndLastKeys,
      itemKey = 'key',
      itemText = 'text',
      label,
      labelProps,
      listItemRenderer = itemText,
      listItemProps,
      maxHeight,
      noDataContent,
      onBlur,
      onChange,
      onFocus,
      onKeyDown,
      onSelect,
      onSelectionChange,
      options = [],
      orientation = 'vertical',
      pagingStepValue = 5,
      selectedKey,
      selectedKeys,
      selectionFollowsFocus,
      selectorPosition = 'middle-start',
      selectionType = 'singleSelectMaster',
      stickyLabel,
      topAlign
    } = props,
    otherProps = __rest(props, ["ariaLabelledby", "bordered", "className", "groupLabelRenderer", "groupProps", "hideOuterFocusRing", "infinite", "ignoreFirstAndLastKeys", "itemKey", "itemText", "label", "labelProps", "listItemRenderer", "listItemProps", "maxHeight", "noDataContent", "onBlur", "onChange", "onFocus", "onKeyDown", "onSelect", "onSelectionChange", "options", "orientation", "pagingStepValue", "selectedKey", "selectedKeys", "selectionFollowsFocus", "selectorPosition", "selectionType", "stickyLabel", "topAlign"]);
  const listOfOptions = options || [];
  const isEmpty = listOfOptions.length === 0;
  const isUsingGroups = !isEmpty && Array.isArray(listOfOptions[0]);
  const isMultiSelect = selectionType === 'multiSelect';
  const [selectedOptionKey, setSelectedOptionKey] = (0, _react.useState)(selectedKey);
  const [multiSelectedOptionKeys, setMultiSelectedOptionKeys] = (0, _react.useState)(selectedKeys);
  const [labelHeight, setLabelHeight] = (0, _react.useState)(0);
  const [groupLabelHeight, setGroupLabelHeight] = (0, _react.useState)(0);
  const labelRef = (0, _react.useRef)(null);
  const groupLabelRef = (0, _react.useRef)(null);
  const findFirstNotDisabled = items => items.find(option => option.disabled !== true);
  const firstNonDisabledOptionKey = isUsingGroups ? (0, _listboxUtils.reduceOption)(findFirstNotDisabled(listOfOptions[0]), itemKey) : (0, _listboxUtils.reduceOption)(findFirstNotDisabled(listOfOptions), itemKey);
  const firstFocusableOptionKey = isUsingGroups ? (0, _listboxUtils.reduceOption)((_a = listOfOptions[0]) === null || _a === void 0 ? void 0 : _a[0], itemKey) : (0, _listboxUtils.reduceOption)(listOfOptions === null || listOfOptions === void 0 ? void 0 : listOfOptions[0], itemKey);
  const lastOptionGroup = listOfOptions[listOfOptions.length - 1];
  function isUsingGroupsOptionsCheck(param) {
    return isUsingGroups;
  }
  function isUsingGroupsOptionListCheck(param) {
    return isUsingGroups;
  }
  const lastOptionKey = isUsingGroupsOptionsCheck(lastOptionGroup) ? (0, _listboxUtils.reduceOption)(lastOptionGroup[lastOptionGroup.length - 1], itemKey) : (0, _listboxUtils.reduceOption)(lastOptionGroup, itemKey);
  let totalOptions = 0;
  if (isUsingGroupsOptionListCheck(listOfOptions)) {
    totalOptions = listOfOptions.reduce((prev, curr) => prev + ((curr === null || curr === void 0 ? void 0 : curr.length) || 0), 0);
  } else {
    totalOptions = listOfOptions === null || listOfOptions === void 0 ? void 0 : listOfOptions.length;
  }
  const [activeKeys, setActiveKeys] = (0, _react.useState)();
  const [descendantManager, setDescendantManager] = (0, _react.useState)();
  const classnames = _bind.default.bind(_Listbox.default);
  const labelId = (0, _useUniqueId.default)();
  const listIdPrefix = (0, _useUniqueId.default)();
  const listboxRef = (0, _react.useRef)();
  const getId = (key, groupIndex) => `${listIdPrefix}${ID_SEPARATOR}${key}${ID_SEPARATOR}${groupIndex}`;
  const getIdFromKeys = () => getId(activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.groupIndex);
  const getIdUsingOption = (option, groupIndex) => getId((0, _listboxUtils.reduceOption)(option, itemKey), groupIndex);
  const isOptionActive = (option, groupIndex) => {
    var _a, _b;
    return ((_a = (0, _listboxUtils.reduceOption)(option, itemKey)) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key) === null || _b === void 0 ? void 0 : _b.toString()) && groupIndex === (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.groupIndex);
  };
  const isOptionSelected = option => {
    var _a;
    const optionKey = (_a = (0, _listboxUtils.reduceOption)(option, itemKey)) === null || _a === void 0 ? void 0 : _a.toString();
    if (isMultiSelect) {
      return multiSelectedOptionKeys === null || multiSelectedOptionKeys === void 0 ? void 0 : multiSelectedOptionKeys.some(key => key === optionKey);
    }
    return optionKey === selectedOptionKey;
  };
  const parseKeyAndGroupIndex = node => {
    const nodeId = (node === null || node === void 0 ? void 0 : node.id) || '';
    const idTokens = nodeId.split(ID_SEPARATOR);
    return {
      nodeKey: idTokens === null || idTokens === void 0 ? void 0 : idTokens[1],
      groupIndex: parseInt(idTokens === null || idTokens === void 0 ? void 0 : idTokens[2], 10)
    };
  };
  const _getSelectedOption = keyValue => (0, _listOptions.getSelectedOption)(isUsingGroups ? (0, _arrFlatten.default)(listOfOptions) : listOfOptions, itemKey, keyValue);
  const getInitiallyFocused = () => {
    const initiallyFocusedKey = selectedOptionKey || (multiSelectedOptionKeys === null || multiSelectedOptionKeys === void 0 ? void 0 : multiSelectedOptionKeys[0]) || selectedKey || (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys[0]) || firstFocusableOptionKey;
    const initiallyFocusedGroupIndex = isUsingGroups ? options === null || options === void 0 ? void 0 : options.findIndex(group => group.some(option => (0, _listboxUtils.reduceOption)(option, itemKey) === initiallyFocusedKey)) : 0;
    return {
      initiallyFocusedKey,
      initiallyFocusedGroupIndex
    };
  };
  const findKeystrokeMatchIndex = typedString => {
    if (!typedString || !Array.isArray(options)) {
      return null;
    }
    const findMatch = option => {
      var _a;
      const optionText = (_a = (0, _listboxUtils.reduceOption)(option, itemText)) === null || _a === void 0 ? void 0 : _a.trim();
      return optionText && (typedString === null || typedString === void 0 ? void 0 : typedString.trim()) && (0, _listboxUtils.matcherMethodIgnoreCase)(optionText, typedString);
    };
    const flatOptions = isUsingGroups ? options.flat() : options;
    const filteredOptions = flatOptions.filter(option => !(option === null || option === void 0 ? void 0 : option.divider));
    return filteredOptions.findIndex(findMatch);
  };
  const {
    keyStrokes,
    setKeyStrokes
  } = (0, _useKeyStrokes.useKeyStrokes)({
    onKeyStrokes: typedString => {
      const foundIndex = findKeystrokeMatchIndex(typedString);
      const nodes = descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.getDescendantNodes();
      if (nodes === null || nodes === void 0 ? void 0 : nodes.length) {
        descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.setActiveDescendant(undefined, foundIndex == null ? undefined : nodes[foundIndex]);
      }
    }
  });
  const onActiveDescendantChange = (e, node, prNode) => {
    const {
      nodeKey,
      groupIndex
    } = parseKeyAndGroupIndex(node);
    const prevNode = parseKeyAndGroupIndex(prNode);
    if (!isMultiSelect && selectionFollowsFocus) {
      const nodeOption = _getSelectedOption(nodeKey);
      const prevNodeOption = _getSelectedOption(prevNode === null || prevNode === void 0 ? void 0 : prevNode.nodeKey);
      if (nodeKey !== selectedOptionKey && (0, _isFunction.isFunction)(onChange)) {
        onChange(e, (nodeOption === null || nodeOption === void 0 ? void 0 : nodeOption.disabled) ? undefined : nodeKey, (nodeOption === null || nodeOption === void 0 ? void 0 : nodeOption.disabled) ? undefined : nodeOption, (prevNodeOption === null || prevNodeOption === void 0 ? void 0 : prevNodeOption.disabled) ? undefined : prevNode === null || prevNode === void 0 ? void 0 : prevNode.nodeKey, (prevNodeOption === null || prevNodeOption === void 0 ? void 0 : prevNodeOption.disabled) ? undefined : prevNodeOption);
      }
      if ((0, _isFunction.isFunction)(onSelect) && !(nodeOption === null || nodeOption === void 0 ? void 0 : nodeOption.disabled)) {
        onSelect(e, nodeKey, nodeOption);
      }
      setSelectedOptionKey((nodeOption === null || nodeOption === void 0 ? void 0 : nodeOption.disabled) ? null : nodeKey);
    }
    setActiveKeys({
      key: nodeKey,
      groupIndex
    });
  };
  const handleSelectionChange = (event, node, wasSelected) => {
    const {
      nodeKey
    } = parseKeyAndGroupIndex(node);
    if (isMultiSelect) {
      if (wasSelected) {
        // remove from state array
        setMultiSelectedOptionKeys(oldArray => oldArray === null || oldArray === void 0 ? void 0 : oldArray.filter(key => key !== nodeKey));
      } else {
        // add to state array
        setMultiSelectedOptionKeys(oldArray => [...(oldArray !== null && oldArray !== void 0 ? oldArray : []), nodeKey]);
      }
      if ((0, _isFunction.isFunction)(onSelectionChange)) {
        onSelectionChange(event, nodeKey, !wasSelected, _getSelectedOption(nodeKey));
      }
    } else {
      // fire onChange only if selection changes
      if (nodeKey !== selectedOptionKey) {
        if ((0, _isFunction.isFunction)(onChange)) {
          onChange(event, nodeKey, _getSelectedOption(nodeKey), selectedOptionKey, _getSelectedOption(selectedOptionKey));
        }
        setSelectedOptionKey(nodeKey);
      }
      // fire onSelect for every selection event
      if ((0, _isFunction.isFunction)(onSelect)) {
        onSelect(event, nodeKey, _getSelectedOption(nodeKey));
      }
    }
  };
  const handleItemClick = (e, node, wasSelected) => {
    var _a;
    const {
      nodeKey,
      groupIndex
    } = parseKeyAndGroupIndex(node);
    (_a = listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current) === null || _a === void 0 ? void 0 : _a.focus({
      preventScroll: true
    });
    handleSelectionChange(e, node, wasSelected);
    setActiveKeys({
      key: nodeKey,
      groupIndex
    });
  };
  const handleOnKeyDown = event => {
    var _a, _b, _c, _d, _e, _f;
    const nodeDisabledValue = (_b = (_a = descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant) === null || _a === void 0 ? void 0 : _a.getAttribute) === null || _b === void 0 ? void 0 : _b.call(_a, 'aria-disabled');
    const nodeDisabled = typeof nodeDisabledValue === 'string' && nodeDisabledValue.toLowerCase() === 'true';
    switch ((0, _keycode.default)(event)) {
      case 'space':
        event.preventDefault();
        if (keyStrokes) {
          setKeyStrokes(`${keyStrokes} `);
        } else {
          if (nodeDisabled) {
            break;
          }
          handleItemClick(event, descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant, ((_c = descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant) === null || _c === void 0 ? void 0 : _c.ariaSelected) === 'true');
        }
        break;
      case 'enter':
        if (nodeDisabled) {
          break;
        }
        handleItemClick(event, descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant, ((_d = descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.activeDescendant) === null || _d === void 0 ? void 0 : _d.ariaSelected) === 'true');
        break;
      default:
        if (
        // if control/command key is pressed, don't add to keyStrokes
        // eg. Crl+C, Cmd+C
        !event.ctrlKey && !event.metaKey && (0, _isPrintableKeyEvent.default)(event)) {
          event.stopPropagation();
          const nextKeyStroke = ((_f = (_e = (0, _keycode.default)(event)) === null || _e === void 0 ? void 0 : _e.replace) === null || _f === void 0 ? void 0 : _f.call(_e, 'numpad ', '')) || '';
          setKeyStrokes(keyStrokes + nextKeyStroke);
        }
        break;
    }
    if ((0, _isFunction.isFunction)(onKeyDown)) {
      onKeyDown(event, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, _getSelectedOption(activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key));
    }
  };
  const getActiveDescendantNode = () => document.getElementById(getIdFromKeys());
  const attachDescendantManager = () => {
    if ((listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current) && !descendantManager) {
      setDescendantManager(new _descendantManager.DescendantManager({
        trapNode: listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current,
        getDescendantNodes: () => {
          var _a;
          return Array.prototype.slice.call((_a = listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('li[role="option"]'));
        },
        getActiveDescendantNode,
        onActiveDescendantChange,
        ignoreFirstAndLastKeys,
        stepValue: pagingStepValue,
        nextKeyCode: orientation === 'horizontal' ? [_keycode.default.codes.right, _keycode.default.codes.down] : _keycode.default.codes.down,
        previousKeyCode: orientation === 'horizontal' ? [_keycode.default.codes.left, _keycode.default.codes.up] : _keycode.default.codes.up
      }));
    }
  };
  const handleFocus = event => {
    const {
      initiallyFocusedKey,
      initiallyFocusedGroupIndex
    } = getInitiallyFocused();
    setActiveKeys({
      key: initiallyFocusedKey,
      groupIndex: initiallyFocusedGroupIndex
    });
    if ((0, _isFunction.isFunction)(onFocus)) {
      onFocus(event);
    }
  };
  const handleBlur = event => {
    setActiveKeys(undefined);
    if ((0, _isFunction.isFunction)(onBlur)) {
      onBlur(event);
    }
  };
  // Scroll to active node if it is not in view.
  // If it is the first or last node, scroll to the beginning or end
  // of the listbox
  const scrollToActive = (activeNode, isFirstOrLast) => {
    if (!activeNode || !listboxRef.current) return;
    let stickyOffset = 0;
    if (stickyLabel) stickyOffset = labelHeight;
    if (isUsingGroups && groupLabelHeight) stickyOffset += groupLabelHeight;
    // an active node exists so let's scroll appropriately
    // added a 5px buffer to account for nodes not being completely
    // in view when scrolled
    if (orientation === 'horizontal') {
      const activeNodeRight = activeNode.offsetLeft + activeNode.offsetWidth + 5;
      const listboxRight = listboxRef.current.scrollLeft + listboxRef.current.offsetWidth;
      if (activeNode.offsetLeft - stickyOffset <= listboxRef.current.scrollLeft) {
        if (isFirstOrLast) {
          listboxRef.current.scrollLeft = 0;
        } else {
          listboxRef.current.scrollLeft = activeNode.offsetLeft - stickyOffset;
        }
      } else if (activeNodeRight >= listboxRight) {
        if (isFirstOrLast) {
          listboxRef.current.scrollLeft = activeNodeRight;
        } else {
          listboxRef.current.scrollLeft = activeNodeRight - listboxRef.current.offsetWidth;
        }
      }
    } else {
      const activeNodeBottom = activeNode.offsetTop + activeNode.offsetHeight + 5;
      const listboxBottom = listboxRef.current.scrollTop + listboxRef.current.offsetHeight;
      if (activeNode.offsetTop - stickyOffset <= listboxRef.current.scrollTop) {
        if (isFirstOrLast) {
          listboxRef.current.scrollTop = 0;
        } else {
          listboxRef.current.scrollTop = activeNode.offsetTop - stickyOffset;
        }
      } else if (activeNodeBottom >= listboxBottom) {
        if (isFirstOrLast) {
          listboxRef.current.scrollTop = activeNodeBottom;
        } else {
          listboxRef.current.scrollTop = activeNodeBottom - listboxRef.current.offsetHeight;
        }
      }
    }
  };
  const externalListContextValue = (0, _react.useContext)(_ListContext.ListContext);
  const listContextValue = {
    bordered,
    isUsingGroups,
    selectionType,
    orientation
  };
  (0, _useUniversalLayoutEffect.default)(() => {
    var _a, _b, _c, _d;
    if (stickyLabel) {
      const dimension = orientation === 'vertical' ? 'clientHeight' : 'clientWidth';
      setLabelHeight((_b = (_a = labelRef === null || labelRef === void 0 ? void 0 : labelRef.current) === null || _a === void 0 ? void 0 : _a[dimension]) !== null && _b !== void 0 ? _b : 0);
      setGroupLabelHeight((_d = (_c = groupLabelRef === null || groupLabelRef === void 0 ? void 0 : groupLabelRef.current) === null || _c === void 0 ? void 0 : _c[dimension]) !== null && _d !== void 0 ? _d : 0);
    }
  }, [orientation, stickyLabel]);
  (0, _react.useEffect)(() => {
    setSelectedOptionKey(selectedKey);
  }, [selectedKey]);
  (0, _react.useEffect)(() => {
    const keys = selectedKeys || [];
    if (!Array.isArray(multiSelectedOptionKeys) || !(0, _listOptions.haveSameKeys)(keys, multiSelectedOptionKeys)) {
      setMultiSelectedOptionKeys(keys);
    }
  }, [selectedKeys]);
  (0, _react.useEffect)(() => {
    if (!activeKeys) {
      descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.detach();
      setDescendantManager(undefined);
      return;
    }
    if (!isMultiSelect && selectionFollowsFocus && !selectedOptionKey) {
      const selectedOption = _getSelectedOption(activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key);
      setSelectedOptionKey((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.disabled) ? undefined : activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key);
      if ((0, _isFunction.isFunction)(onSelect) && !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.disabled)) {
        onSelect(undefined, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, selectedOption);
      }
      if ((0, _isFunction.isFunction)(onChange) && !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.disabled)) {
        onChange(undefined, activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key, selectedOption, undefined, undefined);
      }
    }
    attachDescendantManager();
    const activeNode = document.getElementById(getIdFromKeys());
    const isFirstOrLast = (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key) === firstNonDisabledOptionKey || (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key) === lastOptionKey;
    scrollToActive(activeNode, isFirstOrLast);
    descendantManager === null || descendantManager === void 0 ? void 0 : descendantManager.updateActiveDescendant(() => document.getElementById(getIdFromKeys()));
  }, [activeKeys]);
  (0, _react.useEffect)(() => {
    if (options) {
      const {
        initiallyFocusedKey,
        initiallyFocusedGroupIndex
      } = getInitiallyFocused();
      const activeNode = document.getElementById(getId(initiallyFocusedKey, initiallyFocusedGroupIndex));
      const isFirstOrLast = initiallyFocusedKey === firstNonDisabledOptionKey || initiallyFocusedKey === lastOptionKey;
      scrollToActive(activeNode, isFirstOrLast);
    }
  }, []);
  const renderGroupLabel = group => {
    var _a;
    let groupData = group;
    if (!Array.isArray(group)) {
      groupData = [group];
    }
    return (0, _isFunction.isFunction)(groupLabelRenderer) ? groupLabelRenderer(groupData) : groupLabelRenderer && ((_a = groupData[0]) === null || _a === void 0 ? void 0 : _a[groupLabelRenderer]);
  };
  let posInSet = 0;
  let sizeOfSet;
  if (infinite) {
    sizeOfSet = infinite.hasMore ? -1 : totalOptions;
  }
  const renderItem = (item, itemIndex, groupIndex) => {
    var _a, _b;
    posInSet += 1;
    // allow pre-selected disabled items in multiSelect mode
    const allowSelection = selectionType === 'multiSelect' || !(item === null || item === void 0 ? void 0 : item.disabled);
    return /*#__PURE__*/_react.default.createElement(_ListboxItem.ListboxItem, Object.assign({}, listItemProps, item === null || item === void 0 ? void 0 : item.attributes, {
      selectorPosition: selectorPosition,
      className: classnames(listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.className, (_a = item === null || item === void 0 ? void 0 : item.attributes) === null || _a === void 0 ? void 0 : _a.className, (_b = externalListContextValue === null || externalListContextValue === void 0 ? void 0 : externalListContextValue.optionTypeClassName) === null || _b === void 0 ? void 0 : _b.call(externalListContextValue, item)),
      "aria-posinset": infinite ? posInSet : undefined,
      "aria-setsize": sizeOfSet,
      id: getIdUsingOption(item, groupIndex),
      isActive: isOptionActive(item, groupIndex) && !!descendantManager,
      isSelected: isOptionSelected(item) && allowSelection,
      disabled: item === null || item === void 0 ? void 0 : item.disabled,
      divider: item === null || item === void 0 ? void 0 : item.divider,
      key: `lb-item-${groupIndex}-${itemIndex}`,
      onClick: handleItemClick,
      topAlign: topAlign
    }), !(item === null || item === void 0 ? void 0 : item.divider) && ((0, _isFunction.isFunction)(listItemRenderer) ? listItemRenderer(item) : item[listItemRenderer]));
  };
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--hide-focus-ring`]: hideOuterFocusRing,
    [`${CSS_BLOCK}--${orientation}`]: orientation !== 'vertical',
    [`${CSS_BLOCK}--has-sticky-labels`]: !!stickyLabel
  });
  const labelClasses = classnames(`${CSS_BLOCK}__label`, externalListContextValue === null || externalListContextValue === void 0 ? void 0 : externalListContextValue.gridLabelClassName, labelProps === null || labelProps === void 0 ? void 0 : labelProps.className, {
    [`${CSS_BLOCK}__label--sticky`]: !!stickyLabel
  });
  const labelContent = label && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, labelProps, {
    "aria-hidden": "true",
    id: labelId,
    role: "presentation",
    className: classnames(labelClasses, `${CSS_BLOCK}__label--heading`),
    ref: (0, _reactMergeRefs.default)([labelRef, labelProps === null || labelProps === void 0 ? void 0 : labelProps.ref])
  }), label));
  const [infiniteRef, {
    rootRef
  }] = (0, _reactInfiniteScrollHook.default)({
    loading: false,
    hasNextPage: !!(infinite === null || infinite === void 0 ? void 0 : infinite.hasMore),
    onLoadMore: (_b = infinite === null || infinite === void 0 ? void 0 : infinite.onLoadMore) !== null && _b !== void 0 ? _b : () => undefined,
    rootMargin: '0px 0px 250px 0px'
  });
  const mergedRef = (0, _reactMergeRefs.default)([ref, listboxRef, rootRef]);
  const loadingIndicatorItem = Component => (infinite === null || infinite === void 0 ? void 0 : infinite.hasMore) && (/*#__PURE__*/_react.default.createElement(Component, {
    "aria-hidden": "true",
    className: classnames(labelClasses, `${CSS_BLOCK}__label--infinite`),
    ref: infiniteRef,
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_BusyIndicator.BusyIndicator, {
    message: infinite === null || infinite === void 0 ? void 0 : infinite.message,
    size: (externalListContextValue === null || externalListContextValue === void 0 ? void 0 : externalListContextValue.isGrid) ? 'md' : 'sm',
    type: "inline",
    visible: true
  })));
  const renderListbox = () => {
    const commonProps = {
      'aria-activedescendant': activeKeys ? getIdFromKeys() : undefined,
      'aria-multiselectable': isMultiSelect ? 'true' : undefined,
      'aria-orientation': orientation,
      className: classes,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onKeyDown: handleOnKeyDown,
      onMouseDown: e => {
        e.preventDefault();
      },
      ref: mergedRef,
      style: Object.assign(Object.assign({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style), {
        maxHeight
      }),
      tabIndex: (externalListContextValue === null || externalListContextValue === void 0 ? void 0 : externalListContextValue.disabled) ? -1 : 0
    };
    const stringLabel = typeof label === 'string' ? label : undefined;
    if (isUsingGroups) {
      return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, commonProps, {
        "aria-labelledby": (0, _listboxUtils.getAriaLabelledBy)({
          ariaLabelledby,
          label: stringLabel,
          labelId
        }),
        role: "listbox"
      }), labelContent, options === null || options === void 0 ? void 0 : options.map((group, groupIndex) => (/*#__PURE__*/_react.default.createElement(_ListboxGroup.ListboxGroup, Object.assign({}, groupProps, {
        stickyLabel: stickyLabel,
        labelHeight: labelHeight,
        key: `lb-group-${groupIndex}`,
        ariaLabelledby: ariaLabelledby,
        label: renderGroupLabel(group),
        labelRef: groupLabelRef
      }), group.map((item, itemIndex) => renderItem(item, itemIndex, groupIndex))))), loadingIndicatorItem('div'));
    }
    return /*#__PURE__*/_react.default.createElement(_ListboxGroup.ListboxGroup, Object.assign({}, otherProps, commonProps, {
      stickyLabel: stickyLabel,
      ariaLabelledby: ariaLabelledby,
      label: label
    }), options === null || options === void 0 ? void 0 : options.map((item, itemIndex) => renderItem(item, itemIndex, 0)), loadingIndicatorItem('li'));
  };
  const adjustedListContextValue = (0, _react.useMemo)(() => Object.assign(Object.assign({}, externalListContextValue), listContextValue), [externalListContextValue, listContextValue]);
  if (isEmpty && noDataContent) {
    return noDataContent;
  }
  return /*#__PURE__*/_react.default.createElement(_ListContext.ListContext.Provider, {
    value: adjustedListContextValue
  }, renderListbox());
});
Listbox.displayName = 'Listbox';
var _default = exports.default = Listbox;